import { useGallery, useWindowEvent, AspectRatio, Image } from '@ccg/core';
import React$1, { useState, useRef, useEffect } from 'react';
import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Icon$1 from '../../basics/Icon/Icon.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import Caption$1 from '../Caption/Caption.js';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import Controls$1 from './subcomponents/Controls/Controls.js';
import StyledGallery from './Gallery.style.js';
import Slider$1 from './subcomponents/Slider/Slider.js';
import Overview$1 from './subcomponents/Overview/Overview.js';
import Modal$1 from '../Modal/Modal.js';

const chunkArray = arr => {
  const chunkedArray = [[], [], []];
  let count = 0;
  arr.forEach((item, index) => {
    if (count === 3) count = 0;
    chunkedArray[count].push(_objectSpread2({
      imageIndex: index
    }, item));
    count += 1;
  });
  return chunkedArray;
};

const Gallery = ({
  images,
  caption
}) => {
  const {
    index,
    isOverview,
    handlePrev,
    handleNext,
    handleChange,
    toggleOverview
  } = useGallery(images);
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);
  useWindowEvent('keydown', ({
    key
  }) => {
    if (key === 'ArrowRight') return handleNext();
    if (key === 'ArrowLeft') return handlePrev();
    if (key === 'o') return toggleOverview();
    if (key === 'Escape') return setIsOpen(false);
  });
  useEffect(() => {
    if (isOpen) {
      disableBodyScroll(ref.current);
    } else {
      enableBodyScroll(ref.current);
    }

    return () => {
      clearAllBodyScrollLocks();
    };
  }, [isOpen]);
  const slicedImages = images.slice(0, 9);
  return /*#__PURE__*/React$1.createElement(StyledGallery, null, caption && /*#__PURE__*/React$1.createElement(Caption$1, {
    className: "gallery__meta",
    caption: caption
  }), chunkArray(slicedImages).map((item, i) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  React$1.createElement("div", {
    className: "gallery__row",
    key: `row-${i}`
  }, item.map(({
    id: imageId,
    src,
    srcset,
    alt,
    width,
    height,
    caption: imageCaption,
    imageIndex
  }) => /*#__PURE__*/React$1.createElement("div", {
    className: "gallery__image",
    key: imageId
  }, /*#__PURE__*/React$1.createElement(AspectRatio, {
    ratio: `${width}:${height}`,
    className: "gallery__image-ratio"
  }, /*#__PURE__*/React$1.createElement("button", {
    type: "button",
    className: "gallery__button",
    "aria-label": "Open Gallery",
    onClick: () => {
      setIsOpen(true);
      handleChange(imageIndex);
    }
  }, /*#__PURE__*/React$1.createElement(Image, {
    src: src,
    srcset: srcset,
    sizes: "50vw",
    alt: alt,
    lazy: true
  }), imageCaption && /*#__PURE__*/React$1.createElement(Typography$1, {
    className: "gallery__image-caption",
    variant: "small"
  }, imageCaption), /*#__PURE__*/React$1.createElement(Icon$1, {
    icon: "fullscreen",
    alignment: "none"
  }))))))), /*#__PURE__*/React$1.createElement("div", {
    className: "gallery__overview-button"
  }, /*#__PURE__*/React$1.createElement("button", {
    type: "button",
    "aria-label": "Open Gallery",
    onClick: () => setIsOpen(true)
  }, "Gallery", /*#__PURE__*/React$1.createElement(Icon$1, {
    icon: "fullscreen"
  }))), /*#__PURE__*/React$1.createElement(Modal$1, {
    className: "gallery__modal",
    isOpen: isOpen,
    ref: ref,
    flex: true
  }, !isOverview && images.length > 0 && /*#__PURE__*/React$1.createElement(Slider$1, {
    images: images,
    currentIndex: index,
    handleChange: handleChange
  }), isOverview && images.length > 0 && /*#__PURE__*/React$1.createElement(Overview$1, {
    images: images,
    currentIndex: index,
    handleChange: handleChange
  }), /*#__PURE__*/React$1.createElement(Controls$1, {
    isOverview: isOverview,
    handleNext: handleNext,
    handlePrevious: handlePrev,
    handleClose: () => setIsOpen(false),
    handleOverview: () => toggleOverview(),
    handleChange: handleChange,
    currentIndex: index,
    currentCaption: images[index] && images[index].caption,
    numberOfBullets: images.length
  })));
};

Gallery.propTypes = {
  caption: PropTypes$1.string,
  images: PropTypes$1.arrayOf(PropTypes$1.shape()).isRequired
};
Gallery.defaultProps = {
  caption: null
};

export default Gallery;
